import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const ThemeToggle = () => {
  const [light, setLight] = useState(() => localStorage.getItem("vincen_theme") === "light");

  useEffect(() => {
    document.documentElement.classList.toggle("light", light);
    localStorage.setItem("vincen_theme", light ? "light" : "dark");
  }, [light]);

  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setLight((l) => !l)}
      aria-label="Toggle light or dark mode"
      className="text-zinc-400 hover:text-gold transition-colors duration-300"
    >
      {light ? <Moon size={17} strokeWidth={1.75} /> : <Sun size={17} strokeWidth={1.75} />}
    </button>
  );
};

export default ThemeToggle;
